import React from "react";
import styled from "styled-components";

const Content = styled.div`
  max-width: 100%;
  width: 100%;

  section > header {
    display: inline-flex;
    > span.collapsible-link > a {
      display: inline-flex;
      align-items: center;
    }
  }

  section > article {
    padding-top: 2px;
  }

  .collapsible-panel-open {
    display: block;
    padding-right: 20px;
  }

  .collapsible-panel-close {
    display: none;
  }

  .collapsible-title {
    padding-left: 4px;
  }

  .collapsible-text {
    overflow: auto;
  }
`;

interface ICollapsibleProps {
  title: string;
  text: string;
}

interface ICollapsibleState {
  isCollapsed: boolean;
}

export class Collapsible extends React.Component<ICollapsibleProps, ICollapsibleState> {
  constructor(props: ICollapsibleProps) {
    super(props);
    this.state = { isCollapsed: true };
    this.onClick = this.onClick.bind(this);
  }

  onClick = () => {
    this.setState(state => ({
      isCollapsed: !state.isCollapsed
    }));
  };

  render() {
    return (
      <Content>
        <div>
          <span className="collapsible-link">
            <a onClick={this.onClick}>
              <span className={`${this.state.isCollapsed ? "mi-icon-twisty-collapsed" : "mi-icon-twisty-expanded2"}`}></span>
              <span className="collapsible-title">{this.props.title}</span>
            </a>
          </span>
        </div>
        <div className={`${this.state.isCollapsed ? "collapsible-panel-close" : "collapsible-panel-open"}`}>
          <div className="collapsible-text">
            <pre>{this.props.text}</pre>
          </div>
        </div>
      </Content>
    );
  }
}
